import { InsuranceCompany, MentalHealthRole, ProviderMatchingProfileBookmark } from '@uplift/api';
import { ListItem, NameDisplay, PracticeLocation, ProviderLicense, ProviderMedicalRole, Qualification, SeeClientsEnum, Specialty, TherapeuticStyle, TreatmentApproach } from '@uplift/types';

// structured to meet all field requirements for selected provider components - no more, no less
export type SelectedProviderType = {
  id: string;
  createdAt: string;
  firstName: string;
  lastName: string;
  nameDisplay: NameDisplay;
  medicalRole: ProviderMedicalRole;
  userProfile: {
    preferredName?: string;
    pronouns: string;
    shortBio: string;
    license: ProviderLicense[];
    mentalRoles: MentalHealthRole[];
    practice?: {
      practiceName: string;
      practiceServiceType?: SeeClientsEnum;
      locations: Pick<PracticeLocation, 'id' | 'addressLine1' | 'addressLine2' | 'city' | 'zip' | 'state' | 'hideStreetAddress'>[];
    };
    avatarAsset: {
      url: string;
    };
  };
  supportedAgeGroups: ListItem[];
  modalities: ListItem[];
  specialties: Specialty[];
  treatmentApproach: TreatmentApproach[];
  ethnicity: ListItem[];
  faith: ListItem[];
  communityExpertise: {
    ethnicity: ListItem[];
    faith: ListItem[];
    general: ListItem[];
  };
  genders: ListItem[];
  languages: ListItem[];
  therapeuticStyles: TherapeuticStyle[];
  qualification: Qualification;
  npi: string;
  supportedInsuranceCompanies: InsuranceCompany[];
};

export const enum SelectedProviderTabEnum {
  expertise = 'expertise',
  about = 'about',
  moreInfo = 'moreInfo',
}

export const enum SelectedProviderSubSectionEnum {
  header = 'selectedProviderHeader',
  workWithTheseClients = 'workWithTheseClients',
  specialties = 'specialties',
  treatmentApproach = 'treatmentApproach',
  communityExpertise = 'communityExpertise',
  bio = 'bio',
  spokenLanguages = 'spokenLanguages',
  identifiesAs = 'identifiesAs',
  therapeuticStyle = 'therapeuticStyle',
  licenses = 'licenses',
  education = 'education',
  practiceAddress = 'practiceAddress',
  timeOnUplift = 'timeOnUplift',
  npi = 'npi',
}

export type SelectedProviderFieldTransitionConfig = {
  shown: boolean;
  transitionIn: boolean;
  active: boolean;
};

export type SelectedProviderSectionProps = {
  fieldTransitions?: { [key in ProviderMatchingProfileBookmark]?: SelectedProviderFieldTransitionConfig };
  forceMobile?: boolean;
};
